<template>
  <div :class="$options.name">
    <v-card width="650px">
      <v-card-text>
        В данной области производится надстройка над механизмами построения маршрутов.
        Возможно указать слои и события, используемые в качестве рисков
        на маршрутах, а так же указать лимит вывода.

        <layers-select
          v-model="form.layers"
          :data="data.settings.layers"
          :items-list="layersList"
        />
      </v-card-text>

      <v-card-actions>
        <div class="d-flex flex-grow-1" />
        <v-btn :loading="isLoading" color="primary" @click="onSave">Сохранить настройки</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import get from 'lodash/get';
import LayersSelect from '@/components/page/layers/layers-select';

const createDefaultForm = () => ({
  limit: null,
  layers: [],
});

export default {
  name: 'routes-settings-view',
  asyncData({ store }) {
    const actions = [
      store.dispatch('settings/getRoutesSettings'),
      store.dispatch('layer-objects/getFullList'),
    ];

    return Promise.all(actions);
  },
  components: { LayersSelect },
  data: () => ({
    form: createDefaultForm(),
    isLoading: false,
    data: null,
  }),
  computed: {
    ...mapState('layer-objects', {
      layersList: 'fullList',
    }),
    ...mapState('settings', ['single']),
  },
  created() {
    this.data = {
      ...this.form,
      settings: {
        layers: get(this.single.settings, 'layers', []).map(_ => ({ id: _ })),
        events: get(this.single.settings, 'events', []).map(_ => ({ id: _ })),
      },
    };

    if (get(this.single, 'settings')) {
      const layers = get(this.single.settings, 'layers', []);

      this.form = {
        ...this.form,
        layers: layers.filter(Boolean).map(_ => ({ id: _ })),
      };
    }
  },
  methods: {
    ...mapActions('settings', ['saveRouteSettings']),

    async onSave() {
      this.isLoading = true;
      const data = {
        id: get(this.single, 'id', null),
        settings: {
          ...this.form,
        },
      };

      await this.saveRouteSettings(data);

      this.isLoading = false;
    },
  },
};
</script>
